import {Component, HostListener, OnInit} from '@angular/core';
import {ItemDto} from "../../models/item-dto";
import {HttpErrorResponse} from "@angular/common/http";
import {ItemHttpService} from "../../http-requests/item-http.service";
import {CategoryDto} from "../../models/category-dto";
import {CategoryHttpService} from "../../http-requests/category-http.service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {CompositionHttpService} from "../../http-requests/composition-http.service";
import {TagHttpService} from "../../http-requests/tag-http.service";
import {TagDto} from "../../models/tag-dto";
import {PermissionService} from "../../_auth/permission.service";
import {AlertLevel} from "../../enums/alert-level";
import {PopUps} from "../../enums/pop-ups";
import {AlertBannerModel} from "../../models/alert-banner-model";
import {ItemService} from "../../_services/dto-services/item.service";
import {forkJoin, Observable, Subscription} from "rxjs";
import {ReplaceDtoElementModel} from "../../models/misc/replace-dto-element-model";
import {GlobalAlertService} from "../../_services/global-alert.service";
import {AppRoutes} from "../../enums/routes";
import {DeviceInformation} from "../../_modules/signalRTracker/x-models/device-information";
import {PlatformScannerService} from "../../_services/platform-scanner.service";
import {Platform} from "../../enums/platform";
import {Unit, UnitConverter} from "../../enums/unit";
import {SupplierService} from "../../_modules/company/_services/_dto-services/supplier.service";
import {UrlHelper} from "../../helpers/url-helper";
import {Composition_Create} from "../../_modules/inventory/_models/composition-create";
import {queue} from "../../helpers/delay-helper";
import {Component_Create} from "../../_modules/inventory/_models/component-create";
import {
  InterchangeableComponentGroup_Create
} from "../../_modules/inventory/_models/interchangeable-component-group-create";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {
  InterchangeableGroupAttachedWidgetComponent
} from "../../_modules/inventory/interchangeable-group-attached-widget/interchangeable-group-attached-widget.component";
import {NgOptionComponent, NgSelectComponent} from "@ng-select/ng-select";
import {CheckboxComponent} from "../../_components/checkbox/checkbox.component";
import {LoadingComponent} from "../../_modules/x-components/loading/loading.component";
import {PageScrollableComponent} from "../../_components/page-scrollable/page-scrollable.component";
import {FormContainerComponent} from "../../_components/form-container/form-container.component";
import {HeaderContainerComponent} from "../../_components/header-container/header-container.component";
import {PageContainerComponent} from "../../_components/page-container/page-container.component";
import {App} from "../../app-injector";
import {MatTooltip} from "@angular/material/tooltip";
import {ItemTagPickerComponent} from "../item-tag-picker/item-tag-picker.component";
import {UnitAmountFieldComponent} from "../../_modules/inventory/unit-amount-field/unit-amount-field.component";
import {
  CompositionSlotReorderComponent
} from "../../_modules/inventory/composition-slot-reorder/composition-slot-reorder.component";
import {NgSelectScrollAwareDirective} from "../../_directives/ng-select-scroll-aware.directive";

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.scss'],
  imports: [
    CommonModule, FormsModule, InterchangeableGroupAttachedWidgetComponent, NgOptionComponent, NgSelectComponent, CheckboxComponent, LoadingComponent, PageScrollableComponent, FormContainerComponent, HeaderContainerComponent, PageContainerComponent, RouterLink, MatTooltip, ItemTagPickerComponent, UnitAmountFieldComponent, NgSelectScrollAwareDirective,
    CompositionSlotReorderComponent
  ]
})
export class ItemsComponent implements OnInit {
  //public items?: ItemDto[] = undefined;
  public filtered_items?: ItemDto[];
  public categories?: CategoryDto[] = undefined;
  public newItemName: string = "";
  public newItemCategory?: CategoryDto;
  public error?: HttpErrorResponse;
  public compositionError?: HttpErrorResponse;
  public inverse: boolean = false;
  public field: string = "";
  public qCategory: CategoryDto | undefined;
  public compositionCreator: boolean = false;
  public searchText: string = "";
  public tags: TagDto[] = [];

  public editingItem: ItemDto | undefined;

  //PopUps
  public visiblePopUp: PopUps = PopUps.None;

  sourceDetailPPU: number | undefined;
  sourceDetailVPU: number | undefined;
  sourceDetailUPB: number | undefined;
  sourceDetailSK: string | undefined;
  supplierId: string = "";
  sourceDetailInvId: number | undefined;

  // suppliers: SupplierDto[] | undefined;

  // ComponentNl[] = [];
  viewportWidth: number = 0;
  Platform = Platform;
  public SupplierService: SupplierService | undefined;
  units = Object.entries(Unit).slice(0, Object.entries(Unit).length / 2 - 1);
  protected create: Composition_Create = new Composition_Create();
  protected items: { [key: string]: ItemDto } = {};
  //}
  protected readonly AlertLevel = AlertLevel;

  //AddToComposition(itemId: string, filter: boolean = true) {
  //  if (itemId == "" && this.itemService.items != undefined && this.itemService.items.length > 0) itemId = this.itemService.items[0].id;
  //  if (this.components.find(x => x.item == itemId) != undefined && filter) return;
  //  let component = new ComponentNl();
  //  component.filter = filter;
  //  component.item = itemId;
  //  component.unitString = UnitConverter.GetString(this.itemService.getItemInItems(itemId)!.unit)
  //  this.components.push(component)
  protected readonly PopUps = PopUps;
  //}
  protected readonly DeviceInformation = DeviceInformation;

  //RemoveFromComposition(index: number) {
  //  this.components.splice(index, 1);
  protected readonly JSON = JSON;
  protected readonly Object = Object;
  protected readonly Unit = Unit;
  protected readonly Number = Number;
  protected readonly UnitConverter = UnitConverter;
  private itemsChangedSubscription: Subscription | undefined;
  private category: string | undefined;
  private composition: string | undefined;

  constructor(private itemHttpService: ItemHttpService,
              private categoryHttpService: CategoryHttpService,
              private compositionHttpService: CompositionHttpService,
              private tagHttpService: TagHttpService,
              private route: ActivatedRoute, private router: Router,
              public PermissionService: PermissionService,
              public itemService: ItemService,
              private globalAlertService: GlobalAlertService,
              public PlatformScannerService: PlatformScannerService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  protected get isEditMode(): boolean {
    return this.create.isEditing;
  }

  OpenSourceDetailsPopup(item: ItemDto) {
    this.editingItem = this.itemService.getItemInItems(item.id);
    this.visiblePopUp = PopUps.EditSourceDetails;
    this.sourceDetailVPU = item.latestSourceDetail?.volumePerUnit;
    this.sourceDetailPPU = item.latestSourceDetail?.pricePerUnit;
    this.sourceDetailUPB = item.latestSourceDetail?.unitsPerBundle;
    this.sourceDetailSK = item.latestSourceDetail?.supplierKey;
    this.sourceDetailInvId = item.latestSourceDetail?.inventoryId;
    this.supplierId = item.latestSourceDetail != undefined && item.latestSourceDetail.supplier != undefined ? item.latestSourceDetail.supplier.id : "";
  }

  AssignCopy() {
    if (this.itemService.items == undefined) {
      this.filtered_items = [];
      return;
    }

    this.updateItems(this.itemService.items);
    this.filtered_items = Object.assign([], this.itemService.items.filter(c => c.category.id == this.category || this.category === undefined));
    this.SortByField()
  }

  FilterItem(value: string) {
    this.searchText = value;
    if (!value) {
      this.AssignCopy();
    } else {
      this.filtered_items = Object.assign([], this.itemService.items?.filter(item =>
        item.name.toLowerCase().indexOf(value.toLowerCase()) > -1 && (item.category.id == this.category || this.category == undefined)
      ))
    }
    this.SortByField()
  }

  AddToCompositionRework(item: ItemDto | undefined, filter: boolean = true) {
    if (!item) item = this.GetFirstItem();
    if (item && this.create.components.find(x => x.item == item!.id) && filter) return;

    let component = new Component_Create();
    component.item = item!.id;
    component.filter = filter;
    this.create.components.push(component);

    const element = document.getElementById("component-container");
    if (element) {
      queue().then(() => {
        element.scrollTo({
          top: element.scrollHeight,
          behavior: "smooth"
        })
      })
    }
  }

  RemoveFromCompositionsRework(component: Component_Create) {
    this.create.components.splice(this.create.components.indexOf(component), 1);
  }

  /**
   * Moves one "Bestandteil" one place up or down in the article's slot list (Bug #728).
   *
   * The list order on this screen is the article's slot arrangement: the server stamps it onto
   * `CompositionComponentLinker.Order` when the article is saved, and the register's "Bestandteile" wizard,
   * the modification lines on a receipt and every other consumer render the slots in it. Until #728 there was
   * no order field at all, so the arrangement was whatever a query happened to return — and the only way to
   * change it here was to delete a slot and re-add it at the end.
   *
   * A move at either end of the list is a no-op rather than a wrap-around: the buttons are disabled there, so
   * reaching this with an out-of-range target means something else called it, and silently teleporting a slot
   * from top to bottom would be the wrong answer to that.
   */
  MoveComponent(component: Component_Create, direction: 'up' | 'down') {
    const from = this.create.components.indexOf(component);
    if (from < 0) return;

    const to = direction === 'up' ? from - 1 : from + 1;
    if (to < 0 || to >= this.create.components.length) return;

    // Swap in place. `splice`-out-then-`splice`-in would also work, but a swap keeps every OTHER row's index
    // untouched, which matters because the template tracks by `$index`.
    const moved = this.create.components[from];
    this.create.components[from] = this.create.components[to];
    this.create.components[to] = moved;
  }

  TrackByIndex(index: number, obj: any): any {
    return index;
  }

  setNewItemCategory(id: string) {
    this.newItemCategory = this.categories?.find(x => x.id == id);
  }

  AddItem(): void {
    if (this.newItemName.isNullOrWhitespace()) {
      this.globalAlertService.createAndShow("Fehler", "Bitte geben Sie einen Namen für das Item ein.", AlertLevel.error);
      return;
    }

    this.itemHttpService.add(this.newItemName, this.newItemCategory?.id).subscribe(x => {
      if (this.itemService.items == undefined) this.itemService.items = []
      this.error = undefined;
      this.itemService.items.splice(0, 0, x);
      //this.items.push(x);
      this.newItemName = "";
      this.FilterItem(this.searchText);
      this.globalAlertService.createAlertBannerModel("Erfolgreich erstellt", `Das Item ${x.name} wurde erfolgreich erstellt`, AlertLevel.success, 2000);
      this.globalAlertService.show();
    }, error => {
      this.globalAlertService.createAlertBannerModel("Fehler", "Das Item konnte nicht erstellt werden.", AlertLevel.error, 2000);
      this.globalAlertService.show();
    });
  }

  RemoveItem(item: ItemDto): void {
    let confirmation = confirm("Are you sure you want to delete the following item:\n" + item.name + "\n" + item.id);
    if (!confirmation) return;
    this.itemHttpService.delete(item.id).subscribe(x => {
      this.error = undefined;
      this.itemService.items!.splice(this.itemService.items!.indexOf(item), 1);
      this.FilterItem(this.searchText);
      this.globalAlertService.createAlertBannerModel("Item gelöscht", `Das Item ${item.name} wurde erfolgreich gelöscht.`, AlertLevel.success, 2000);
      this.globalAlertService.show();
    }, error => {
      this.globalAlertService.createAlertBannerModel("Fehler", "Das Löschen des Items ist fehlgeschlagen.", AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  SetInvNumber(item: ItemDto): void {
    let invNumber = prompt("Neue Inventar-Nummer:", item.latestSourceDetail?.inventoryId?.toFixed(0) ?? "");
    this.itemHttpService.setSourceDetail(
      item.id,
      item.latestSourceDetail?.pricePerUnit ?? 0,
      item.latestSourceDetail?.volumePerUnit ?? 0,
      item.latestSourceDetail?.unitsPerBundle ?? 0,
      item.latestSourceDetail?.supplierKey ?? "",
      item.latestSourceDetail?.supplier?.id ?? "",
      invNumber == undefined ? undefined : parseInt(invNumber)
    ).subscribe(x => {
      this.itemService.items!.splice(this.itemService.items!.indexOf(item), 1, x);
      this.FilterItem(this.searchText);
    }, error => {
      console.error(error)
      this.globalAlertService.createAlertBannerModel("Fehler", "Inventarnummer konnte nicht gesetzt werden.", AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
    //this.itemHttpService.setInvNumber(item.id, invNumber == undefined ? 0 : parseInt(invNumber)).subscribe(x => {
    //  item.invNumber = x.invNumber;
    //}, error => {
    //
    //});
  }

  SortBy(field: string) {

    if (field == this.field) this.inverse = !this.inverse;
    else this.inverse = false;

    // Allows functions to use the same sorting method if items are refreshed
    this.field = field;
    this.SortByField();
  }

  SortByField() {
    /**
     * Sorts the items by the field specified in this.field
     *
     * @return void
     */
    if (this.filtered_items == undefined) this.filtered_items = []

    switch (this.field) {
      case "name":
        this.filtered_items.sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          return 0;
        });
        break;
      case "created":
        this.filtered_items.sort((a, b) => {
          if (a.created > b.created) return 1;
          if (a.created < b.created) return -1;
          return 0;
        })
        break;
      case "category":
        this.filtered_items.sort((a, b) => {
          if (a.category.name.toLowerCase() > b.category.name.toLowerCase()) return 1;
          if (a.category.name.toLowerCase() < b.category.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
          return 0;
        })
        break;
      case "invnb":
        this.filtered_items.sort((a, b) => {
          return (a.latestSourceDetail?.inventoryId ?? 0) - (b.latestSourceDetail?.inventoryId ?? 0);
        })
    }
    if (this.inverse) this.filtered_items.reverse();
  }

  fetchCategories(): Observable<CategoryDto[]> {
    if (this.PermissionService.CheckPermission(this.PermissionService.Inventory_Category_Get()))
      return this.categoryHttpService.list()
    return new Observable<CategoryDto[]>();
  }

  fetchTags(): Observable<TagDto[]> {
    if (this.PermissionService.CheckPermission(this.PermissionService.Inventory_Tag_List()))
      return this.tagHttpService.list();
    return new Observable<TagDto[]>();
  }

  initializeCategories(result: CategoryDto[]): void {
    this.categories = result;
    if (this.categories.length > 0)
      if (this.category == undefined) this.newItemCategory = this.categories[0];
      else this.newItemCategory = this.categories.find(x => x.id == this.category)

    if (this.category != undefined) {
      this.qCategory = this.categories?.find(x => x.id == this.category);
    }
  }


  // Alert Banner Functions

  initializeTags(result: TagDto[]): void {
    this.tags = result.filter(c => !c.allCompositions);
  }

  initializeSupplierService() {
    if (this.PermissionService.CheckPermission(this.PermissionService.Company_Supplier_List())) {
      this.SupplierService = App.Injector.get(SupplierService);
      if (this.SupplierService) {
        this.SupplierService.EntityChanged.subscribe({
          next: async x => {
            if (this.supplierId == x?.id) {
              let sid = this.supplierId;
              this.supplierId = "";
              queue().then(() => {
                if (this.SupplierService?.Entities?.find(x => x.id == sid)) this.supplierId = sid;
              })
            }
          }
        })
      }
      //this.supplierHttpService.list().subscribe(x => {
      //  this.suppliers = x;
      //}, error => {
      //  console.error(error);
      //  this.globalAlertService.createAlertBannerModel("Fehler", "Lieferanten konnten nicht geladen werden.", AlertLevel.error, 2000);
      //  this.globalAlertService.show();
      //})
    }
  }

  LoadData() {
    forkJoin({
      tags: this.fetchTags(),
      categories: this.fetchCategories()
    }).subscribe(results => {
      this.initializeCategories(results.categories);
      this.initializeTags(results.tags);
      this.setEditMode()
      this.initializeSupplierService();
    }, error => console.error(error));

    // load items as list
    /*this.itemHttpService.list(this.category).subscribe(result => {
      this.itemService.items = result;
      this.AssignCopy();
    }, error => console.error(error));*/


  }

  saveItemSourceDetails() {
    this.itemHttpService.setSourceDetail(this.editingItem?.id ?? "",
      this.sourceDetailPPU ?? 0,
      this.sourceDetailVPU ?? 0,
      this.sourceDetailUPB ?? 0,
      this.sourceDetailSK ?? "",
      this.supplierId,
      this.sourceDetailInvId).subscribe(x => {
      if (this.itemService.items == undefined) this.itemService.items = []
      this.error = undefined;
      this.itemService.items.splice(this.itemService.items.indexOf(this.editingItem!), 1, x);
      this.FilterItem(this.searchText);

      this.globalAlertService.createAlertBannerModel("Änderung erfolgreich", `Die Details von ${this.editingItem?.name} wurden erfolgreich gespeichert.`, AlertLevel.success, 2000);
      this.globalAlertService.show();

      this.editingItem = undefined;
      this.sourceDetailPPU = undefined;
      this.sourceDetailVPU = undefined;
      this.sourceDetailUPB = undefined;
      this.sourceDetailSK = undefined;
      this.sourceDetailInvId = undefined;

      this.supplierId = '';
      this.closePopUps();
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Speichern fehlgeschlagen", "Speichern der Details ist fehlgeschlagen. Bitte Werte überprüfen.", AlertLevel.error, 2000);
      this.globalAlertService.show();
    })
  }

  SetCategory(id: string = "") {
    this.router.navigate(['.'], {relativeTo: this.route, queryParams: {category: id}});
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.getViewportWidth();
  }

  redirectToSettings(id: string) {
    this.router.navigate([AppRoutes.ItemSettings], {queryParams: {id: id}});
  }

  //Popups
  closePopUps() {
    /**
     * Closes all pop ups
     *
     * @return void
     */
    this.editingItem = undefined;
    this.visiblePopUp = PopUps.None
  }

  ItemChanged(item: ItemDto) {
    /**
     * Replaces the element in the items array with the updated one
     * Applies the filter and sorting
     *
     */

    if (this.editingItem === undefined) {
      window.location.reload();
      // ToDo: The Banner wont show in this case
      //this.ShowAlertBanner("Ein Fehler ist aufgetreten."," Die Daten wurden erneut vom Server geladen.", AlertLevel.info)
    }

    let _ReplaceDtoElementModel: ReplaceDtoElementModel<ItemDto> = this.itemService.replaceItemGetNewOldItem(item);
    this.editingItem = undefined;


    // Apply filter and sorting
    this.FilterItem(this.searchText);
    // this.SortByField()


    this.ShowAlertBanner("Item aktualisiert.", "Name erfolgreich von '" + _ReplaceDtoElementModel.OldElement?.name + "' in '" + _ReplaceDtoElementModel.NewElement?.name + "' geändert.", AlertLevel.success)
  }

  /* new methods */

  ErrorBanner(message: string) {
    /**
     * Triggers the alert banner to show an error message.
     *
     * @param message The message to show
     *
     * @returns void
     */
    this.ShowAlertBanner("Error.", message, AlertLevel.error);
  }

  ShowAlertBanner(header: string, message: string, level: AlertLevel) {
    /**
     * Triggers the alert banner to show a message.
     *
     * @param header The header of the message
     * @param message The message to show
     * @param level The level of the message
     *
     * @returns void
     */


    this.globalAlertService.show(new AlertBannerModel(header, message, level));
  }

  ChangeUnitType(item: ItemDto, event: Event) {
    this.itemHttpService.setUnit(item.id, event).subscribe(x => {
      this.globalAlertService.createAlertBannerModel("Einheit geändert", "Die Einheit wurde erfolgreich geändert.", AlertLevel.success, 2000);
      this.globalAlertService.show();
      if (this.itemService.items == undefined) return;
      this.itemService.replaceItem(x);
    }, error => {
      console.error(error);
      this.globalAlertService.createAlertBannerModel("Fehler", "Einheit konnte nicht geändert werden.", AlertLevel.error, 2000);
      this.globalAlertService.show();
      if (this.itemService.items == undefined) return;
      this.itemService.replaceItem(item);
    })
  }

  setEditMode() {
    // http://localhost:4200/items?composition=21bfb3c7-3a49-4322-8bd3-f8ad8f8324ce
    this.route.queryParams.subscribe({
      next: params => {
        let composition = params.composition;
        if (composition == "") composition = undefined;
        this.composition = composition;
        if (this.composition == undefined) return;

        this.compositionHttpService.get(this.composition)
          .withLoadingIndicator()
          .subscribe({
            next: value => {
              this.create = Composition_Create.from(value);
              this.compositionCreator = true;
            },
            error: error => {
              console.error(error);
              this.globalAlertService.createAndShow("Fehler", "Der Artikel konnte nicht geladen werden.", AlertLevel.error);
              this.redirectToArticleCategory(this.category);
            }
          })
      }
    })
  }

  getTagById(id: string): TagDto | undefined {
    return this.tags.find(x => x.id == id);
  }

  redirectToArticleCategory(id: string | undefined) {
    // redirect to the Compositions page with the type as parameter
    this.router.navigate([AppRoutes.Compositions], {queryParams: {type: id, other: false}}).then();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let category = params.category;
      if (category == "") category = undefined;
      this.category = category;

      let composition = params.composition;
      if (composition == "") composition = undefined;
      this.composition = composition;
    })

    this.getViewportWidth();
    this.itemService.fetchItems();
    this.subscribeToItemsChanged();
    this.LoadData()
  }

  ngOnDestroy(): void {
    this.itemsChangedSubscription?.unsubscribe();
  }

  protected GetItem(id: string | undefined): ItemDto | undefined {
    if (!id) return undefined;
    return this.items[id];
  }

  protected GetFirstItem(): ItemDto {
    if (this.itemService.items && this.itemService.items.length > 0) return this.itemService.items[0];
    this.globalAlertService.createAndShow("Fehler", "Es wurden keine Items gefunden.", AlertLevel.error);
    throw new Error("No items found, cannot add to composition.");
  }

  protected upsertComposition(clear: boolean = true) {
    let error = this.create.validate();

    if (!!error) {
      this.globalAlertService.createAndShow("Fehler", `Ein Fehler ist aufgetreten: ${error}`, AlertLevel.error);
      return;
    }

    this.compositionHttpService.upsert(this.create).subscribe({
      next: value => {
        this.globalAlertService.createAndShow("Erfolgreich", `Der Artikel ${value.name} wurde erfolgreich ${this.isEditMode ? "aktualisiert" : "erstellt"}.`);

        if (!clear && !this.isEditMode) return;
        if (clear && !this.isEditMode) {
          this.reset();
          return;
        }

        if (this.isEditMode) {
          let cType = UrlHelper.QueryParams.compositionType;
          // if (!cType) return;
          console.log("CompositionType", cType);
          this.redirectToArticleCategory(cType);
        }
      },
      error: error => {
        console.error(error);
        this.globalAlertService.createAndShow("Fehler", "Der Vorgang konnte nicht abgeschlossen werden.", AlertLevel.error);
      }
    })
  }

  protected isTagSelected(tag: TagDto): boolean {
    return this.create.tags.indexOf(tag.id) > -1;
  }

  protected toggleTag(tag: TagDto): void {
    // no tag toggle in edit mode
    if (this.isEditMode) return;

    if (this.isTagSelected(tag)) {
      this.create.tags.splice(this.create.tags.indexOf(tag.id), 1);
    } else {
      this.create.tags.push(tag.id);
    }
  }

  protected AddInterchangeableComponent(component: Component_Create): void {
    component.interchangeableGroup = new InterchangeableComponentGroup_Create();
  }

  protected TryAddInterchangeableComponent(component: Component_Create, addOption: boolean = false): void {
    if (component.interchangeableGroup == undefined) this.AddInterchangeableComponent(component);
    if (addOption && component.interchangeableGroup!.components.length == 0) {
      component.interchangeableGroup!.components.push(Component_Create.create(this.GetFirstItem(), false));
    }
  }

  protected OptionalChanged(isOptional: boolean, component: Component_Create): void {
    if (isOptional) this.TryAddInterchangeableComponent(component, true);
    component.SetOptional(isOptional, this.GetFirstItem());
  }

  private reset() {
    this.create = new Composition_Create();
    this.compositionCreator = false;
  }

  private getViewportWidth(): void {
    this.viewportWidth = window.innerWidth;
  }

  private subscribeToItemsChanged() {
    this.itemsChangedSubscription = this.itemService.itemsChanged.subscribe(
      () => {
        this.AssignCopy();
        this.FilterItem(this.searchText);
      }
    );
  }

  private updateItems(items: ItemDto[]): void {
    this.items = {};
    items.forEach(x => this.items[x.id] = x);
  }
}
